import React from "react";
import { useNavigate } from "react-router-dom";

const CalfPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .cf-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #ecfdf5 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .cf-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .cf-hero {
          padding: 26px 22px 34px;
          border-radius: 28px;
          background: linear-gradient(120deg, rgba(34, 197, 94, 0.22), rgba(45, 212, 191, 0.12));
          margin-bottom: 36px;
          display: grid;
          grid-template-columns: minmax(0, 1.5fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .cf-hero {
            grid-template-columns: 1fr;
          }
        }

        .cf-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(34, 197, 94, 0.2);
          color: #15803d;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .cf-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #22c55e;
        }

        .cf-title {
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .cf-subtitle {
          font-size: 15px;
          max-width: 560px;
          color: #374151;
        }

        .cf-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 16px 0 18px;
        }

        .cf-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .cf-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 10px;
        }

        .cf-btnPrimary,
        .cf-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .cf-btnPrimary {
          background: #22c55e;
          color: #022c22;
          box-shadow: 0 10px 24px rgba(34, 197, 94, 0.4);
        }

        .cf-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 14px 32px rgba(34, 197, 94, 0.55);
        }

        .cf-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .cf-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .cf-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .cf-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* GENERIC SECTIONS */
        .cf-stripe {
          padding: 32px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.35);
        }

        .cf-sectionTitle {
          font-size: 21px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .cf-sectionSubtitle {
          font-size: 14px;
          color: #4b5563;
          margin-bottom: 18px;
        }

        .cf-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .cf-flexCol {
          flex: 1 1 260px;
        }

        .cf-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        /* LISTS */
        .cf-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 8px;
        }

        .cf-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .cf-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          background: #22c55e;
          margin-top: 6px;
          flex-shrink: 0;
        }

        /* CARD GRID */
        .cf-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .cf-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .cf-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .cf-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TWO-COLUMN GRID SECTION */
        .cf-twoColGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 20px;
          margin-top: 18px;
        }

        .cf-pillBox {
          padding: 14px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.03);
        }

        .cf-pillTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 6px;
        }

        .cf-pillText {
          font-size: 13px;
          color: #4b5563;
        }

        /* BANNER */
        .cf-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 24px;
        }

        .cf-banner img {
          width: 100%;
          height: 240px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .cf-banner img {
            height: 270px;
          }
        }

        .cf-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.82), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 10px;
        }

        .cf-bannerText {
          color: #dcfce7;
          font-size: 15px;
          max-width: 420px;
        }

        .cf-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .cf-bannerButtons button {
          font-size: 12px;
          padding: 8px 14px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .cf-bannerButtons .primary {
          background: #22c55e;
          color: #022c22;
        }

        .cf-bannerButtons .secondary {
          background: rgba(255,255,255,0.18);
          color: #f9fafb;
          border: 1px solid rgba(255,255,255,0.6);
        }

        /* BOTTOM STRIP */
        .cf-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .cf-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .cf-bottomText strong {
          color: #bbf7d0;
        }

        .cf-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .cf-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .cf-bottomActions .primary {
          background: #22c55e;
          color: #022c22;
        }

        .cf-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .cf-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="cf-page">
        <div className="cf-inner">
          {/* HERO */}
          <section className="cf-hero">
            <div>
              <div className="cf-tag">
                <span className="cf-tagDot" />
                Calf Muscles
              </div>
              <h1 className="cf-title">
                Help your calves feel strong and springy again, not tight and cranky.
              </h1>
              <p className="cf-subtitle">
                Your calf muscles—gastrocnemius and soleus—help you push off when you walk, climb stairs,
                and stand on your toes. When they&apos;re irritated or overworked, they can feel tight, sore,
                or vulnerable to “pulls.”
              </p>

              <div className="cf-chips">
                <span className="cf-chip">Calf tightness</span>
                <span className="cf-chip">“Pulled calf” episodes</span>
                <span className="cf-chip">Soreness with walking or stairs</span>
                <span className="cf-chip">Cramping after activity</span>
              </div>

              <div className="cf-ctaRow">
                <button
                  className="cf-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book a calf visit →
                </button>
                <button
                  className="cf-btnSecondary"
                  onClick={() => navigate("/staff")}
                >
                  Meet our therapists
                </button>
              </div>
            </div>

            <div className="cf-heroImgWrap">
              <img
                src="/content/calf/calf_hero.png"
                alt="Therapist assessing calf muscles"
                className="cf-heroImg"
              />
            </div>
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="cf-stripe">
            <div className="cf-sectionTitle">What can go wrong in the calf?</div>
            <p className="cf-sectionSubtitle">
              The calf complex helps control your ankle, support your body weight, and absorb force.
              With sudden overload, changes in activity, or limited support from other muscles, it can
              start signaling for help.
            </p>

            <div className="cf-flexRow">
              <div className="cf-flexCol">
                <ul className="cf-list">
                  <li>
                    <span className="cf-bullet" />
                    <span>
                      A sharp “pull” feeling in the calf during a step, sprint, or quick push-off.
                    </span>
                  </li>
                  <li>
                    <span className="cf-bullet" />
                    <span>
                      Persistent tightness that seems to come back after walking, running, or long standing.
                    </span>
                  </li>
                  <li>
                    <span className="cf-bullet" />
                    <span>
                      Soreness in the upper calf (gastrocnemius) after hills, stairs, or sport.
                    </span>
                  </li>
                  <li>
                    <span className="cf-bullet" />
                    <span>
                      Deeper, lower calf fatigue (soleus) after longer walks or prolonged standing.
                    </span>
                  </li>
                  <li>
                    <span className="cf-bullet" />
                    <span>
                      Cramping or feeling like the calf might “seize” during certain efforts.
                    </span>
                  </li>
                </ul>

                <div className="cf-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="cf-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    See if this sounds like you →
                  </button>
                  <button
                    className="cf-btnSecondary"
                    onClick={() => navigate("/contact")}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="cf-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/calf/calf_gastrocnemius.png"
                  alt="Manual therapy on gastrocnemius"
                  className="cf-img"
                />
              </div>
            </div>

            <div className="cf-cardGrid">
              <div className="cf-card">
                <div className="cf-cardTitle">Gastrocnemius</div>
                <div className="cf-cardText">
                  The larger, more visible calf muscle that works harder with straight-knee activities like
                  running, jumping, and brisk walking.
                </div>
              </div>
              <div className="cf-card">
                <div className="cf-cardTitle">Soleus</div>
                <div className="cf-cardText">
                  A deeper calf muscle that works especially when the knee is slightly bent, important for
                  standing, walking, and balance.
                </div>
              </div>
            </div>
          </section>

          {/* SOLEUS / DEEP CALF */}
          <section className="cf-stripe">
            <div className="cf-flexRow">
              <div className="cf-flexCol">
                {/* NOTE: this one is JPG on purpose */}
                <img
                  src="/content/calf/calf_soleus.jpg"
                  alt="Therapist treating deeper soleus muscle"
                  className="cf-img"
                />
              </div>

              <div className="cf-flexCol">
                <div className="cf-sectionTitle">That deep, nagging lower-calf fatigue</div>
                <p className="cf-sectionSubtitle">
                  The soleus often quietly handles a lot of your daily load. When it’s irritated, the calf can
                  feel tired, heavy, or stubbornly tight, especially after time on your feet.
                </p>

                <ul className="cf-list">
                  <li>
                    <span className="cf-bullet" />
                    <span>
                      Tired, heavy feeling in the lower calf after walking or standing.
                    </span>
                  </li>
                  <li>
                    <span className="cf-bullet" />
                    <span>
                      Tightness that doesn&apos;t fully ease with quick stretches alone.
                    </span>
                  </li>
                  <li>
                    <span className="cf-bullet" />
                    <span>
                      Discomfort when doing bent-knee activities like squatting or slow stair work.
                    </span>
                  </li>
                </ul>

                <div className="cf-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="cf-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Start calf-focused PT →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="cf-stripe">
            <div className="cf-sectionTitle">How physical therapy supports your calves</div>
            <p className="cf-sectionSubtitle">
              We look at how your foot, ankle, knee, and hips share the work with the calf, and build a plan
              that helps you move with confidence again.
            </p>

            <div className="cf-twoColGrid">
              <div className="cf-pillBox">
                <div className="cf-pillTitle">Calm the area down</div>
                <div className="cf-pillText">
                  Hands-on treatment, gentle stretching, and position changes that respect your current pain level
                  and healing stage.
                </div>
              </div>
              <div className="cf-pillBox">
                <div className="cf-pillTitle">Rebuild calf strength safely</div>
                <div className="cf-pillText">
                  Gradual loading for both gastrocnemius and soleus—starting at easy levels and progressing as
                  you tolerate more.
                </div>
              </div>
              <div className="cf-pillBox">
                <div className="cf-pillTitle">Improve ankle & foot mechanics</div>
                <div className="cf-pillText">
                  Checking how your ankle and foot move so the calf isn&apos;t doing all the work alone.
                </div>
              </div>
              <div className="cf-pillBox">
                <div className="cf-pillTitle">Support your activity goals</div>
                <div className="cf-pillText">
                  Whether you&apos;re walking for exercise, working on your feet, or returning to sport, we tailor
                  the plan to where you want to go.
                </div>
              </div>
            </div>

            <div className="cf-ctaRow" style={{ marginTop: "18px" }}>
              <button
                className="cf-btnPrimary"
                onClick={() => navigate("/appointments")}
              >
                Book a calf session →
              </button>
              <button
                className="cf-btnSecondary"
                onClick={() => navigate("/insurance")}
              >
                Check my insurance
              </button>
            </div>
          </section>

          {/* EXERCISES / VISIT FLOW */}
          <section className="cf-stripe">
            <div className="cf-flexRow">
              <div className="cf-flexCol">
                <img
                  src="/content/calf/calf_strengthening.png"
                  alt="Patient doing calf strengthening exercises"
                  className="cf-img"
                />
              </div>

              <div className="cf-flexCol">
                <div className="cf-sectionTitle">What a calf session may look like</div>

                <div className="cf-twoColGrid">
                  <div className="cf-pillBox">
                    <div className="cf-pillTitle">1. Your story</div>
                    <div className="cf-pillText">
                      We talk through when your calf started bothering you, what brings it on, and what you
                      want to get back to.
                    </div>
                  </div>
                  <div className="cf-pillBox">
                    <div className="cf-pillTitle">2. Motion & strength check</div>
                    <div className="cf-pillText">
                      We gently test ankle motion, calf strength, and how your foot and knee move with you.
                    </div>
                  </div>
                  <div className="cf-pillBox">
                    <div className="cf-pillTitle">3. Hands-on & guided movement</div>
                    <div className="cf-pillText">
                      You try specific manual techniques, stretches, and loading strategies to see what helps.
                    </div>
                  </div>
                  <div className="cf-pillBox">
                    <div className="cf-pillTitle">4. Simple home plan</div>
                    <div className="cf-pillText">
                      You leave with a short, realistic routine you can keep up with—no long list to memorize.
                    </div>
                  </div>
                </div>

                <div className="cf-ctaRow" style={{ marginTop: "16px" }}>
                  <button
                    className="cf-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book a calf evaluation →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="cf-stripe">
            <div className="cf-banner">
              <img
                src="/content/calf/calf_banner.png"
                alt="Bright PT clinic for calf and lower leg care"
              />
              <div className="cf-bannerOverlay">
                <div className="cf-bannerText">
                  Calf sessions happen in a calm, one-on-one environment where we match your plan to your
                  comfort level, work demands, and activity goals.
                </div>
                <div className="cf-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule a calf visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* SAFETY NOTE */}
          <section className="cf-stripe">
            <div className="cf-bottomStrip">
              <div className="cf-bottomText">
                If you notice sudden severe calf pain with a popping sensation, can&apos;t walk, see a large bruise
                or deformity, or have calf pain with warmth, redness, swelling, unexplained shortness of breath,{" "}
                <strong>seek urgent or emergency medical care first.</strong> Physical therapy can then help guide
                safe recovery once serious causes are ruled out.
              </div>
              <div className="cf-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Schedule calf PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default CalfPT;
